"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEAM_ERROR_CODES = exports.updateTeamMemberSchema = exports.createTeamMemberSchema = exports.NOTIFICATION_EMAIL_NOTICE = exports.TEAM_LEVEL_DESCRIPTIONS = void 0;
exports.notificationAddress = notificationAddress;
const zod_1 = require("zod");
const roles_js_1 = require("./roles.js");
/**
 * Team di supporto (PRD-002 US-2, DEC-004, DEC-007): anagrafica delle persone che possono
 * ricevere un ticket e, dalla story #12, entrare nella suite. Contratti condivisi fra API e web.
 */
/** Compito di ciascun livello, mostrato nella schermata Team. */
exports.TEAM_LEVEL_DESCRIPTIONS = {
    primo: 'Riceve le segnalazioni, le classifica, risponde a chi ha segnalato e le chiude.',
    secondo: 'Interviene sui ticket passati al secondo livello: correzioni e rilasci.',
};
/**
 * Avviso sull'indirizzo di notifica (PRD-002 US-2): l'interfaccia lo dichiara perché un indirizzo
 * sbagliato rende invisibile l'assegnazione.
 */
exports.NOTIFICATION_EMAIL_NOTICE = "L'indirizzo di notifica è quello a cui arriva l'assegnazione: se è sbagliato, l'assegnazione resta invisibile.";
const emailSchema = zod_1.z
    .string()
    .trim()
    .toLowerCase()
    .max(254, { error: 'Indirizzo email troppo lungo' })
    .pipe(zod_1.z.email({ error: 'Indirizzo email non valido' }));
const nameSchema = zod_1.z
    .string()
    .trim()
    .min(1, { error: 'Il nome è obbligatorio' })
    .max(120, { error: 'Nome troppo lungo (massimo 120 caratteri)' });
/** Email di notifica opzionale: stringa vuota o assente significa «uguale all'email Google». */
const notificationEmailSchema = zod_1.z
    .string()
    .trim()
    .nullish()
    .transform((value) => (value ? value : null))
    .pipe(emailSchema.nullable());
/** Corpo di `POST /team/members`. */
exports.createTeamMemberSchema = zod_1.z
    .object({
    name: nameSchema,
    /** Email aziendale Google: chiave d'accesso alla suite (DEC-007), non modificabile dopo la creazione. */
    email: emailSchema,
    notificationEmail: notificationEmailSchema,
    role: zod_1.z.enum(roles_js_1.ROLES, { error: 'Ruolo non valido' }),
    level: zod_1.z.enum(roles_js_1.TEAM_LEVELS, { error: 'Livello non valido' }),
})
    // Una notifica uguale all'email Google equivale a nessuna notifica separata.
    .transform((value) => (value.notificationEmail === value.email ? { ...value, notificationEmail: null } : value));
/** Corpo di `PATCH /team/members/:id`: solo i campi presenti vengono aggiornati. */
exports.updateTeamMemberSchema = zod_1.z
    .object({
    name: nameSchema,
    notificationEmail: notificationEmailSchema,
    role: zod_1.z.enum(roles_js_1.ROLES, { error: 'Ruolo non valido' }),
    level: zod_1.z.enum(roles_js_1.TEAM_LEVELS, { error: 'Livello non valido' }),
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, { error: 'Nessun campo da aggiornare' });
/** Codici di errore del team, nel campo `code` del corpo di errore dell'API. */
exports.TEAM_ERROR_CODES = {
    /** Esiste già un membro attivo con la stessa email Google. */
    emailAlreadyInTeam: 'team.email_already_in_team',
    /** Il membro non esiste o è stato rimosso. */
    memberNotFound: 'team.member_not_found',
    /** Il membro è responsabile di ticket aperti: prima va cambiato il responsabile (DEC-004). */
    memberHasOpenTickets: 'team.member_has_open_tickets',
    /** È l'unico amministratore attivo: non si può rimuovere né retrocedere (DEC-006, DEC-007). */
    lastAdmin: 'team.last_admin',
};
/** Indirizzo effettivo delle notifiche di assegnazione. */
function notificationAddress(member) {
    return member.notificationEmail ?? member.email;
}
//# sourceMappingURL=team.js.map